/* F77 — carrinho lateral: posição no celular + "Continuar comprando" (07/10/2026).
 *
 * No iPhone (Chrome) o carrinho abria ~90 px acima da área visível: o título sumia atrás da
 * barra do navegador e a página do produto aparecia embaixo do "Finalizar compra". Elemento
 * com position: fixed é desenhado no lugar errado quando a barra de endereço está recolhida.
 *
 * Enquanto o carrinho está aberto, ele deixa de ser "fixed" e passa a ser ancorado na própria
 * página: topo = quanto a página está rolada, altura = a altura visível. Conteúdo normal de
 * página o navegador sempre desenha dentro da área visível. O CSS fica em f77-ajustes.css
 * (.drawer--cart.f77-ancorado). Só no celular; no computador nada muda.
 */
(function () {
  'use strict';
  var CELULAR = window.matchMedia('(max-width: 749px)');
  var raiz = document.documentElement;
  var carrinho = null;
  var aberto = false;

  function medir() {
    if (!aberto) return;
    var vv = window.visualViewport;
    // offsetTop cobre o caso em que a área visível está deslocada dentro da página (teclado aberto)
    var topo = (window.pageYOffset || raiz.scrollTop || 0) + (vv ? vv.offsetTop : 0);
    var altura = vv ? vv.height : window.innerHeight;
    raiz.style.setProperty('--f77-carrinho-topo', Math.max(0, Math.round(topo)) + 'px');
    raiz.style.setProperty('--f77-carrinho-altura', Math.round(altura) + 'px');
  }

  function sincronizar() {
    if (!carrinho) return;
    var deveAncorar = carrinho.classList.contains('is-open') && CELULAR.matches;
    if (deveAncorar === aberto) { medir(); return; }
    aberto = deveAncorar;
    carrinho.classList.toggle('f77-ancorado', aberto);
    if (aberto) medir();
  }

  function ligar() {
    carrinho = document.querySelector('cart-drawer.drawer--cart, cart-drawer#cart-drawer');
    if (!carrinho) return;
    new MutationObserver(sincronizar).observe(carrinho, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', medir, { passive: true });
    window.addEventListener('resize', medir);
    window.addEventListener('orientationchange', medir);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', medir);
      window.visualViewport.addEventListener('scroll', medir);
    }
    if (CELULAR.addEventListener) CELULAR.addEventListener('change', sincronizar);
    sincronizar();
  }

  // "Continuar comprando" (abaixo do Finalizar): fecha o carrinho. Delegado no documento porque o
  // rodapé do carrinho é redesenhado a cada mudança de item.
  document.addEventListener('click', function (ev) {
    var alvo = ev.target && ev.target.closest ? ev.target.closest('[data-f77-continuar]') : null;
    if (!alvo) return;
    ev.preventDefault();
    var c = document.querySelector('cart-drawer.drawer--cart, cart-drawer#cart-drawer');
    if (c && typeof c.closeCartDrawer === 'function') c.closeCartDrawer();
    else if (/\/cart(\?|$)/.test(location.pathname + location.search)) location.href = '/collections/all';
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})();
